import { BigButton } from "./BigButton";
import { openUrl } from "./openUrl";
import { BUTTONS } from "../buttons";

export const UcOnlineButton = () => {
	const button = BUTTONS.UC_ONLINE;
	return (
		<BigButton
			label={button.label}
			backgroundUrl={button.backgroundUrl}
			onClick={() => {
				if (button.href) {
					openUrl(button.href);
				}
			}}
		/>
	);
};
